/* beadboo — «Anything we should know?» (snippets/beadboo-note.liquid), 2026-09-07.
   Общий для PDP и standalone-конструктора.

   PDP: textarea и три скрытых file-инпута привязаны к форме продукта атрибутом form=,
   Dawn собирает FormData(form) и шлёт multipart в /cart/add — файлы уезжают свойствами
   позиции `Photo 1..3`. Пустые инпуты держим disabled (не попадают в FormData),
   textarea включаем только когда в ней есть текст — иначе в корзину уедет пустое
   свойство «Note for us».
   Builder: bb-builder.js читает note() и files() и собирает FormData сам. */
if (!customElements.get('beadboo-note')) {
  customElements.define(
    'beadboo-note',
    class BeadbooNote extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = '1';
        this.max = parseInt(this.dataset.max, 10) || 3;
        this.maxBytes = (parseFloat(this.dataset.maxMb) || 10) * 1048576;
        this.details = this.querySelector('[data-bbn-details]');
        this.ta = this.querySelector('[data-bbn-ta]');
        this.picker = this.querySelector('[data-bbn-picker]');
        this.add = this.querySelector('[data-bbn-add]');
        this.photos = this.querySelector('[data-bbn-photos]');
        this.err = this.querySelector('[data-bbn-err]');
        this.done = this.querySelector('[data-bbn-done]');
        this.slots = Array.prototype.slice.call(this.querySelectorAll('[data-bbn-slot]'));
        this.thumbs = {}; // slot → элемент миниатюры

        if (this.ta) {
          // disabled нужен только на момент отправки; для набора текста поле должно жить
          this.ta.disabled = false;
          this.ta.addEventListener('input', () => this.sync());
        }
        if (this.picker) this.picker.addEventListener('change', () => this.onPick());
        if (this.details) this.details.addEventListener('toggle', () => this.sync());

        // PDP: перед сабмитом формы продукта выключаем пустой textarea (capture —
        // раньше обработчика Dawn, который строит FormData)
        const formId = this.dataset.formId;
        if (formId) {
          document.addEventListener(
            'submit',
            (e) => {
              if (e.target && e.target.id === formId && this.ta) {
                this.ta.disabled = !this.ta.value.trim();
                // вернуть поле к жизни после ответа сервера, чтобы можно было дописать
                setTimeout(() => { if (this.ta) this.ta.disabled = false; }, 1500);
              }
            },
            true
          );
        }
        this.sync();
      }

      /* ── публичный API для конструктора ── */
      note() {
        return this.ta ? this.ta.value.trim() : '';
      }
      files() {
        return this.slots
          .filter((s) => s.files && s.files.length)
          .map((s) => ({ slot: parseInt(s.dataset.bbnSlot, 10), file: s.files[0] }));
      }

      count() {
        return this.slots.filter((s) => s.files && s.files.length).length;
      }

      showErr(msg) {
        if (!this.err) return;
        this.err.textContent = msg;
        this.err.hidden = !msg;
      }

      onPick() {
        this.showErr('');
        const list = Array.prototype.slice.call(this.picker.files || []);
        for (const f of list) {
          const free = this.slots.find((s) => !(s.files && s.files.length));
          if (!free) { this.showErr('Up to ' + this.max + ' photos — remove one to add another.'); break; }
          if (f.type && f.type.indexOf('image/') !== 0) { this.showErr('Photos only, please (JPG, PNG, HEIC).'); continue; }
          if (f.size > this.maxBytes) { this.showErr('That one is over ' + Math.round(this.maxBytes / 1048576) + ' MB — a phone screenshot works fine.'); continue; }
          try {
            const dt = new DataTransfer();
            dt.items.add(f);
            free.files = dt.files;
            free.disabled = false;
          } catch (e) {
            this.showErr('Your browser couldn’t attach that photo — you can also email it to help@beadboo.com.');
            continue;
          }
          this.addThumb(free, f);
        }
        this.picker.value = '';
        this.sync();
      }

      addThumb(slot, file) {
        const t = document.createElement('div');
        t.className = 'bbn__thumb';
        const img = document.createElement('img');
        img.alt = '';
        img.width = 60;
        img.height = 60;
        try { img.src = URL.createObjectURL(file); } catch (e) { /* HEIC без превью — миниатюра пустая, файл всё равно уедет */ }
        const x = document.createElement('button');
        x.type = 'button';
        x.className = 'bbn__x';
        x.setAttribute('aria-label', 'Remove photo');
        x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        x.addEventListener('click', () => {
          slot.value = '';
          slot.disabled = true;
          if (img.src) { try { URL.revokeObjectURL(img.src); } catch (e) { /* noop */ } }
          t.remove();
          delete this.thumbs[slot.dataset.bbnSlot];
          this.showErr('');
          this.sync();
        });
        t.appendChild(img);
        t.appendChild(x);
        this.photos.insertBefore(t, this.add);
        this.thumbs[slot.dataset.bbnSlot] = t;
      }

      sync() {
        const n = this.count();
        const hasNote = this.note().length > 0;
        const bits = [];
        if (hasNote) bits.push('1 note');
        if (n) bits.push(n + (n === 1 ? ' photo' : ' photos'));
        if (this.done) this.done.textContent = bits.join(' · ');
        this.classList.toggle('has-content', bits.length > 0);
        if (this.add) this.add.classList.toggle('is-full', n >= this.max);
      }
    }
  );
}
